import React from "react";
import {Objects} from "components";
import {Link} from "react-router-dom";

const userColors = ["#FF0000", "#673ab7", "#ff9800", "#025E05",
	"#03a9f4", "#A00000", "#4caf50", "#8bc34a", "#cddc39",
	"#ff5722", "#9c27b0", "#795548", "#3f51b5", "#607d8b",
	"#000000", "#FF0000", "#673ab7", "#ff9800", "#025E05",
	"#03a9f4", "#A00000", "#4caf50", "#8bc34a", "#cddc39",
	"#ff5722", "#9c27b0", "#795548", "#3f51b5", "#607d8b",
	"#000000"]

class FERadiusMap extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			refresh: this.props.refresh,
			fes: []
		};
	}

	render() {
		return (
			<div className={'row'}>
				<div className={'col-10'}>
					<Objects.FERadiusMap
						history={this.props.history}
						reloadShell={this.props.reloadShell}
						reloadPage={this.refreshPage}
						reloadSelf={this.state.refresh}
						regions={this.props.regions}
						setSelectedFe={this.setSelectedFe}
						customerPin={this.state.customerPin}
						setFes={(fes) => {this.setState({fes})}}
					/>
				</div>
				<div className={'col-2'}>
					<p>If an FE does not show on the map, they do not have a lat/lng for their home address. If they have no circle, they have no radius set.</p>
					<div key={"region_Card"}>
						<div className={'row'} style={{alignItems: 'center', marginTop: '2px', marginBottom: '2x'}}>
							<div className={'col-12'} style={{justifyContent: 'center', alignSelf: 'center', display: 'flex'}}>

									<p style={{fontSize: '22px', fontWeight: 'bolder', color: "#000000"}}>Region Border</p>

							</div>
						</div>
					</div>
					{this.state.fes?.map((fe, i) => {
						return (
							<div key={fe.pkey + " Card"}>
								<div className={'row'} style={{alignItems: 'center', marginTop: '2px', marginBottom: '2x'}}>
									<div className={'col-12'} style={{justifyContent: 'center', alignSelf: 'center', display: 'flex'}}>
										<Link to={`/users/${fe.pkey}`} target={'_blank'}>
											<p style={{fontSize: '18px', fontWeight: 'bolder', color: userColors[i]}}>{fe.name_first + " " + fe.name_last}</p>
										</Link>
									</div>
								</div>
							</div>
						)
					})}
				</div>
			</div>
		)
	}
}

export default FERadiusMap;
